"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _config = require("../../config");

var _antd = require("antd");

var _lodash = _interopRequireDefault(require("lodash"));

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

var _security = require("../../utils/security");

var _reactDeviceDetect = require("react-device-detect");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SubMenu = _antd.Menu.SubMenu;

var Sidebar =
/*#__PURE__*/
function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar(props) {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sidebar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getRootMenuItems", function () {
      return _config.Config.get("menu", "menuItems");
    });

    _defineProperty(_assertThisInitialized(_this), "getMenuOpenKeysByPath", function (menuItems, pathname, primaryMenuKey, menuItemKey, parentMenuItem) {
      var openMenuKey;
      var openMenuItemKey;

      for (var i = 0; i < menuItems.length; i++) {
        var index = i; // TODO: refactor redirection logic

        if (menuItems[i].redirectTo) {
          index = _lodash["default"].findIndex(parentMenuItem ? parentMenuItem : menuItems, {
            path: menuItems[i].redirectTo.menu
          });
        }

        var mk = primaryMenuKey ? primaryMenuKey : 'menu-' + index;
        var mik = menuItemKey ? menuItemKey + '-' + index : 'menu-' + index;

        if (_lodash["default"].has(menuItems[i], 'menuItems')) {
          var _this$getMenuOpenKeys = _this.getMenuOpenKeysByPath(menuItems[i].menuItems, pathname, mk, mik, menuItems[index].menuItems);

          var _this$getMenuOpenKeys2 = _slicedToArray(_this$getMenuOpenKeys, 2);

          openMenuKey = _this$getMenuOpenKeys2[0];
          openMenuItemKey = _this$getMenuOpenKeys2[1];
        }

        if (openMenuKey) {
          break;
        }

        if (menuItems[i].path === pathname) {
          return [mk, mik];
        }
      }

      return [openMenuKey, openMenuItemKey];
    });

    _defineProperty(_assertThisInitialized(_this), "info", function () {
      _antd.Modal.info({
        title: 'Under development',
        content: _react["default"].createElement("div", null, "We are sorry, this feature is under development"),
        onOk: function onOk() {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuItems", function (items, key) {
      return items.map(function (item, i) {
        return _this.renderMenuItem(item, key + '-' + i);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "wrapTooltip", function (tooltip, content) {
      var translate = _this.props.translate;
      return tooltip && _Utils["default"].getOrientation() !== 'portrait' ? _react["default"].createElement(_antd.Tooltip, {
        overlayStyle: {
          wordWrap: "break-word"
        },
        className: 'sales-menu-tooltip',
        placement: "bottomLeft",
        title: translate(tooltip),
        mouseLeaveDelay: 0
      }, content) : content;
    });

    _defineProperty(_assertThisInitialized(_this), "wrapLink", function (path, content) {
      return path ? _react["default"].createElement(_reactRouterDom.Link, {
        to: path,
        style: {
          textDecoration: 'none'
        },
        onClick: path ? function () {
          return null;
        } : _this.info
      }, content) : content;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuTitle", function (icon, title, key) {
      var translate = _this.props.translate; // TODO: https://onquality.atlassian.net/projects/DEVPD/issues/DEVPD-91

      var isSalesSubMenu = key && key.startsWith("menu-1-"); // TODO: refactor redirection logic

      if (title === null || title === undefined) return null;

      if (isSalesSubMenu) {
        return _react["default"].createElement("span", null, _react["default"].createElement("span", null, translate(title) + ' '), icon && _react["default"].createElement("i", {
          className: icon
        }));
      } else {
        return _react["default"].createElement("span", null, icon && _react["default"].createElement("i", {
          className: icon
        }), _react["default"].createElement("span", null, translate(title)));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubMenuClick", function (selectedKey, path) {
      var history = _this.props.history;
      history.push(path);

      var _this$getMenuOpenKeys3 = _this.getMenuOpenKeysByPath(_this.getRootMenuItems(), path),
          _this$getMenuOpenKeys4 = _slicedToArray(_this$getMenuOpenKeys3, 2),
          openMenuKey = _this$getMenuOpenKeys4[0],
          selectedMenuItemKey = _this$getMenuOpenKeys4[1];

      _this.setState({
        openKeys: openMenuKey ? [openMenuKey] : [],
        selectedKeys: [selectedMenuItemKey]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkMenuItemShowPermission", function (item) {
      var _this$props = _this.props,
          canAccessPdAccounting = _this$props.canAccessPdAccounting,
          isLogisticsMode = _this$props.isLogisticsMode,
          user = _this$props.user,
          isDevEnvironment = _this$props.isDevEnvironment,
          isTestEnvironment = _this$props.isTestEnvironment;
      var needAccess = item.needAccess,
          hideInLogisticsMode = item.hideInLogisticsMode,
          showOnlyForAdmin = item.showOnlyForAdmin,
          access = item.access,
          onlyOnDevelop = item.onlyOnDevelop,
          onlyOnTest = item.onlyOnTest; // Check environment access

      if (onlyOnDevelop && !isDevEnvironment || onlyOnTest && !isTestEnvironment) {
        return false;
      } // Check permissions


      var show = false; // If menu item has access permission flag, check it

      if (access) {
        show = (0, _security.canAccess)(user, access);
      } else {
        // TODO: refactor permissions. Use common permissions
        show = !needAccess || canAccessPdAccounting;

        if (hideInLogisticsMode && isLogisticsMode) {
          show = false;
        }

        if (showOnlyForAdmin) {
          show = !!_this.props.isAdmin;
        }
      }

      return show;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuItem", function (item, key) {
      var _this$props2 = _this.props,
          translate = _this$props2.translate,
          isDevEnvironment = _this$props2.isDevEnvironment,
          isTestEnvironment = _this$props2.isTestEnvironment;
      var path = item.path,
          isItemGroup = item.isItemGroup,
          title = item.title,
          icon = item.icon,
          tooltip = item.tooltip,
          menuItems = item.menuItems,
          onlyOnDevelop = item.onlyOnDevelop,
          onlyOnTest = item.onlyOnTest;
      if (!_this.checkMenuItemShowPermission(item)) return null;

      if (menuItems && !isItemGroup) {
        return _react["default"].createElement(SubMenu, {
          key: key,
          title: _this.renderMenuTitle(icon, title),
          onTitleClick: function onTitleClick(e) {
            _this.handleSubMenuClick(e.key, path);
          }
        }, _this.wrapTooltip(tooltip, _this.renderMenuItems(menuItems, key)));
      } else if (menuItems && isItemGroup) {
        return _react["default"].createElement(_antd.Menu.ItemGroup, {
          key: key,
          title: translate(title)
        }, _this.wrapTooltip(tooltip, _this.renderMenuItems(menuItems, key)));
      } else {
        return _react["default"].createElement(_antd.Menu.Item, {
          key: key
        }, _this.wrapTooltip(tooltip, _this.wrapLink(path, _this.renderMenuTitle(icon, title, key))));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (e) {
      var openMenuKeys = e.selectedKeys.map(function (key) {
        var p = key.split("-");
        return p[0] + "-" + p[1];
      });

      _this.setState({
        openKeys: openMenuKeys ? openMenuKeys : [],
        selectedKeys: e.selectedKeys
      }); //this.sidebarToggle()

    });

    var _this$getMenuOpenKeys5 = _this.getMenuOpenKeysByPath(_this.getRootMenuItems(), props.location.pathname),
        _this$getMenuOpenKeys6 = _slicedToArray(_this$getMenuOpenKeys5, 2),
        _openMenuKey = _this$getMenuOpenKeys6[0],
        _selectedMenuItemKey = _this$getMenuOpenKeys6[1];

    _this.state = {
      openKeys: _openMenuKey ? [_openMenuKey] : [],
      selectedKeys: _selectedMenuItemKey ? [_selectedMenuItemKey] : []
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.location !== prevProps.location) {
        var _this$getMenuOpenKeys7 = this.getMenuOpenKeysByPath(this.getRootMenuItems(), this.props.location.pathname),
            _this$getMenuOpenKeys8 = _slicedToArray(_this$getMenuOpenKeys7, 2),
            openMenuKey = _this$getMenuOpenKeys8[0],
            selectedMenuItemKey = _this$getMenuOpenKeys8[1];

        this.setState({
          openKeys: openMenuKey ? [openMenuKey] : [],
          selectedKeys: selectedMenuItemKey ? [selectedMenuItemKey] : []
        });
      }
    }
  }, {
    key: "sidebarToggle",
    value: function sidebarToggle(e) {
      if (_reactDeviceDetect.isMobile) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "sidebar",
        style: {
          zIndex: 1
        }
      }, _react["default"].createElement("nav", {
        className: "sidebar-nav"
      }, _react["default"].createElement(_antd.Menu, {
        style: {
          height: '100%',
          borderRight: 0
        },
        selectedKeys: this.state.selectedKeys,
        onSelect: this.onSelect,
        onClick: this.sidebarToggle,
        openKeys: this.state.openKeys,
        forceSubMenuRender: false,
        multiple: false,
        mode: "inline",
        subMenuCloseDelay: 0,
        inlineIndent: 0,
        theme: "dark"
      }, this.renderMenuItems(this.getRootMenuItems(), 'menu'))));
    }
  }]);

  return Sidebar;
}(_react.Component);

exports.Sidebar = Sidebar;